import { FlowStep } from '@varo/graphql-schema-types';
import { router } from 'expo-router';

import { mapToERoute } from './mapToERoute';

export const redirectUserToTargetRoute = (result?: FlowStep) => {
  if (result) {
    const targetRoute = result.currentStep;
    if (targetRoute) {
      const nextStep = mapToERoute(targetRoute);
      router.replace(`${nextStep}?id=${result.id}`);
    }
  }
};
